import React from 'react';
import { useStyleConfig, Flex } from '@chakra-ui/react';
import { ReactComponent as LogoSymbol } from 'resources/images/symbol.svg';

export const ChakraAppLoader: React.FC = () => {
  const styles = useStyleConfig('AppLoader', {});

  return (
    <Flex sx={styles}>
      <LogoSymbol className="loader" data-testid="app-loader" />
    </Flex>
  );
};
